import {useAppUiStore,} from '@/assets/js/src/pinia/appUi'
import {getActivePinia,} from 'pinia'
import {nextTick,} from 'vue'
import {useTranslation,} from "./useTranslation"

export function usePrint () {
    let appUiStore = useAppUiStore(getActivePinia())
    let {t,} = useTranslation()

    return {
        doPrint: function () {
            appUiStore.printing = true
            nextTick(()=> {
                try {
                    window.print()
                    // eslint-disable-next-line no-unused-vars
                } catch (e) {
                    alert(t('async.common.no_print_notice'))
                }
            })
        },
    }
}